import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD,
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID,
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_FAILURE,
    ACTION_TRIALGROUPITEMTEMPLATE_LOAD_SUCCESS,

    ACTION_TRIALGROUPITEMTEMPLATE_SAVE,
    ACTION_TRIALGROUPITEMTEMPLATE_SAVE_SUCCESS,
    ACTION_TRIALGROUPITEMTEMPLATE_SAVE_FAILURE,

    ACTION_TRIALGROUPITEMTEMPLATE_CREATE,
    ACTION_TRIALGROUPITEMTEMPLATE_CREATE_SUCCESS,
    ACTION_TRIALGROUPITEMTEMPLATE_CREATE_FAILURE,

    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE,
    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_SUCCESS,
    ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_FAILURE,

    ACTION_TRIALGROUPITEMTEMPLATE_CLEAR,
    ACTION_TRIALGROUPITEMTEMPLATES_FILTER,

    TrialGroupItemTemplateAction
} from '../actions/trialGroupItemTemplate';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialGroupItemTemplateState {
    formData: Dtos.TrialGroupItemTemplate | Dtos.TrialGroupItemTemplate[],
    formDataTrialed: Dtos.TrialGroupItemTemplateCategory[];
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialGroupItemTemplate[];
    formFilteredDataGrouped: Dtos.TrialGroupItemTemplateCategory[];
}

const initialState: ITrialGroupItemTemplateState = {
    formData: undefined,
    formDataTrialed: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formFilteredDataGrouped: undefined,
};


function loading(state: ITrialGroupItemTemplateState, _isLoading: boolean): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialGroupItemTemplateState,
    formData: Dtos.TrialGroupItemTemplate | Dtos.TrialGroupItemTemplate[],
    formDataTrialed: Dtos.TrialGroupItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formDataTrialed: {
            $set: formDataTrialed
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialGroupItemTemplateState, formFilter: IFormFilter): ITrialGroupItemTemplateState {

    const formData: Dtos.TrialGroupItemTemplate[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = formData ? formData.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    let formFilteredDataGrouped = [];
    if (state.formDataTrialed) {
        for (var i = 0; i < state.formDataTrialed.length; i++) {
            const filteredTrialGroupItemTemplateCategoryItems =
                state.formDataTrialed[i].trialGroupItemTemplates.filter(p => (p.active == true || formFilter.showInActive) &&
                    (formFilter.search == "" ||
                        (p.name != undefined && p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) ||
                        (p.description != undefined && p.description.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)
                    ));
            if (filteredTrialGroupItemTemplateCategoryItems.length > 0) {
                formFilteredDataGrouped.push({
                    ...state.formDataTrialed[i],
                    trialGroupItemTemplates: filteredTrialGroupItemTemplateCategoryItems
                });
            }
        }
    }

    const newState: ITrialGroupItemTemplateState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formFilteredDataGrouped: {
            $set: formFilteredDataGrouped
        }
    });

    return newState;
}

function loadFailure(state: ITrialGroupItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialGroupItemTemplateState, propertiesToClear?: string[]): ITrialGroupItemTemplateState {

    if (!propertiesToClear) {
        const newState: ITrialGroupItemTemplateState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialGroupItemTemplateState, _isSaving: boolean): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialGroupItemTemplateState,
    formData: Dtos.TrialGroupItemTemplate | Dtos.TrialGroupItemTemplate[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialGroupItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialGroupItemTemplateState, _isCreating: boolean): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialGroupItemTemplateState,
    formData: Dtos.TrialGroupItemTemplate,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialGroupItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialGroupItemTemplateState, _isValidating: boolean): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialGroupItemTemplateState,
    formData: Dtos.TrialGroupItemTemplate,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialGroupItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemTemplateState {
    const newState: ITrialGroupItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialGroupItemTemplateReducer: Reducer<ITrialGroupItemTemplateState> = (state: ITrialGroupItemTemplateState = initialState, action: TrialGroupItemTemplateAction) => {
    switch (action.type) {
        case ACTION_TRIALGROUPITEMTEMPLATE_LOAD:
        case ACTION_TRIALGROUPITEMTEMPLATE_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formDataTrialed, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALGROUPITEMTEMPLATE_SAVE:
            return saving(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATE_CREATE:
            return creating(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALGROUPITEMTEMPLATE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATE_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMTEMPLATES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialGroupItemTemplateReducer;